<div class="user-dialog">
  <header class="user-dialog__header">
    <div class="user-dialog__avatar" aria-hidden="true">{{ initials }}</div>
    <div class="user-dialog__identity">
      <span class="user-dialog__eyebrow">Account</span>
      <h2 mat-dialog-title>{{ displayName }}</h2>
      @if (user?.user_email) {
        <p>{{ user?.user_email }}</p>
      }
    </div>
  </header>

  <mat-dialog-content class="user-dialog__content mat-typography">
    @if (user) {
      <dl class="user-dialog__fields">
        @for (field of fields; track field.label) {
          @if (field.value) {
            <div class="user-dialog__field">
              <dt>{{ field.label }}</dt>
              <dd>{{ field.value }}</dd>
            </div>
          }
        }
      </dl>
    } @else {
      <p class="user-dialog__empty">No account information is available.</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="user-dialog__actions" align="end">
    <button mat-flat-button mat-dialog-close cdkFocusInitial>Close</button>
  </mat-dialog-actions>
</div>
